// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompleteSignupRouteImport } from './routes/complete-signup'
import { Route as CheckoutReturnRouteImport } from './routes/checkout-return'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInviteTokenRouteImport } from './routes/accept-invite.$token'
import { Route as AuthenticatedTrainingRouteImport } from './routes/_authenticated/training'
import { Route as AuthenticatedSwipeRouteImport } from './routes/_authenticated/swipe'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPeopleRouteImport } from './routes/_authenticated/people'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedLinksRouteImport } from './routes/_authenticated/links'
import { Route as AuthenticatedLensesRouteImport } from './routes/_authenticated/lenses'
import { Route as AuthenticatedImportsRouteImport } from './routes/_authenticated/imports'
import { Route as AuthenticatedDigestsRouteImport } from './routes/_authenticated/digests'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedCommandCenterRouteImport } from './routes/_authenticated/command-center'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedBonusBuilderRouteImport } from './routes/_authenticated/bonus-builder'
import { Route as AuthenticatedAnomaliesRouteImport } from './routes/_authenticated/anomalies'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated/workspaces.$workspaceId'
import { Route as AuthenticatedIntelligenceProgramComparisonRouteImport } from './routes/_authenticated/intelligence.program-comparison'
import { Route as AuthenticatedTrainingIndexRouteImport } from './routes/_authenticated/training.index'
import { Route as AuthenticatedSwipeIndexRouteImport } from './routes/_authenticated/swipe.index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSettingsWorkspacesRouteImport } from './routes/_authenticated/settings.workspaces'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings.team'
import { Route as AuthenticatedSettingsSupportRouteImport } from './routes/_authenticated/settings.support'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings.profile'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings.notifications'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings.integrations'
import { Route as AuthenticatedSettingsExportsRouteImport } from './routes/_authenticated/settings.exports'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings.billing'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings.account'
import { Route as AuthenticatedLinksIndexRouteImport } from './routes/_authenticated/links.index'
import { Route as AuthenticatedCalendarIndexRouteImport } from './routes/_authenticated/calendar.index'
import { Route as AuthenticatedBonusBuilderIndexRouteImport } from './routes/_authenticated/bonus-builder.index'
import { Route as AuthenticatedBonusBuilderProjectIdRouteImport } from './routes/_authenticated/bonus-builder.$projectId'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminSupportRouteImport } from './routes/_authenticated/admin.support'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminProposalsRouteImport } from './routes/_authenticated/admin.proposals'
import { Route as AuthenticatedAdminPatternsRouteImport } from './routes/_authenticated/admin.patterns'
import { Route as AuthenticatedAdminOverviewRouteImport } from './routes/_authenticated/admin.overview'
import { Route as AuthenticatedAdminNotificationsRouteImport } from './routes/_authenticated/admin.notifications'
import { Route as AuthenticatedAdminImpersonationRouteImport } from './routes/_authenticated/admin.impersonation'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin.audit'
import { Route as AuthenticatedAdminAiUsageRouteImport } from './routes/_authenticated/admin.ai-usage'
import { Route as AuthenticatedWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authenticated/workspaces.$workspaceId.index'
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsRouteImport } from './routes/_authenticated/workspaces.$workspaceId.settings'
import { Route as AuthenticatedWorkspacesWorkspaceIdSecondTierRouteImport } from './routes/_authenticated/workspaces.$workspaceId.second-tier'
import { Route as AuthenticatedWorkspacesWorkspaceIdProductsRouteImport } from './routes/_authenticated/workspaces.$workspaceId.products'
import { Route as AuthenticatedWorkspacesWorkspaceIdPasteRouteImport } from './routes/_authenticated/workspaces.$workspaceId.paste'
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsRouteImport } from './routes/_authenticated/workspaces.$workspaceId.imports'
import { Route as AuthenticatedWorkspacesWorkspaceIdContactsRouteImport } from './routes/_authenticated/workspaces.$workspaceId.contacts'
import { Route as AuthenticatedWorkspacesWorkspaceIdAnomaliesRouteImport } from './routes/_authenticated/workspaces.$workspaceId.anomalies'
import { Route as AuthenticatedTrainingCoursesCourseIdRouteImport } from './routes/_authenticated/training.courses.$courseId'
import { Route as AuthenticatedSettingsIntegrationsPushManagementRouteImport } from './routes/_authenticated/settings.integrations.push-management'
import { Route as AuthenticatedAdminAccountsIndexRouteImport } from './routes/_authenticated/admin.accounts.index'
import { Route as AuthenticatedAdminAccountsAccountIdRouteImport } from './routes/_authenticated/admin.accounts.$accountId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompleteSignupRoute = CompleteSignupRouteImport.update({
            id: '/complete-signup',path: '/complete-signup',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout-return',path: '/checkout-return',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AcceptInviteTokenRoute = AcceptInviteTokenRouteImport.update({
            id: '/accept-invite/$token',path: '/accept-invite/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTrainingRoute = AuthenticatedTrainingRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSwipeRoute = AuthenticatedSwipeRouteImport.update({
            id: '/swipe',path: '/swipe',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPeopleRoute = AuthenticatedPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLinksRoute = AuthenticatedLinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLensesRoute = AuthenticatedLensesRouteImport.update({
            id: '/lenses',path: '/lenses',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedImportsRoute = AuthenticatedImportsRouteImport.update({
            id: '/imports',path: '/imports',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDigestsRoute = AuthenticatedDigestsRouteImport.update({
            id: '/digests',path: '/digests',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCommandCenterRoute = AuthenticatedCommandCenterRouteImport.update({
            id: '/command-center',path: '/command-center',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBonusBuilderRoute = AuthenticatedBonusBuilderRouteImport.update({
            id: '/bonus-builder',path: '/bonus-builder',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAnomaliesRoute = AuthenticatedAnomaliesRouteImport.update({
            id: '/anomalies',path: '/anomalies',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedWorkspacesWorkspaceIdRoute = AuthenticatedWorkspacesWorkspaceIdRouteImport.update({
            id: '/workspaces/$workspaceId',path: '/workspaces/$workspaceId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedIntelligenceProgramComparisonRoute = AuthenticatedIntelligenceProgramComparisonRouteImport.update({
            id: '/intelligence/program-comparison',path: '/intelligence/program-comparison',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTrainingIndexRoute = AuthenticatedTrainingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTrainingRoute
          })
const AuthenticatedSwipeIndexRoute = AuthenticatedSwipeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSwipeRoute
          })
const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsWorkspacesRoute = AuthenticatedSettingsWorkspacesRouteImport.update({
            id: '/workspaces',path: '/workspaces',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsTeamRoute = AuthenticatedSettingsTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsSupportRoute = AuthenticatedSettingsSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsProfileRoute = AuthenticatedSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsNotificationsRoute = AuthenticatedSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsIntegrationsRoute = AuthenticatedSettingsIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsExportsRoute = AuthenticatedSettingsExportsRouteImport.update({
            id: '/exports',path: '/exports',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsBillingRoute = AuthenticatedSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsAccountRoute = AuthenticatedSettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedLinksIndexRoute = AuthenticatedLinksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedLinksRoute
          })
const AuthenticatedCalendarIndexRoute = AuthenticatedCalendarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedCalendarRoute
          })
const AuthenticatedBonusBuilderIndexRoute = AuthenticatedBonusBuilderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedBonusBuilderRoute
          })
const AuthenticatedBonusBuilderProjectIdRoute = AuthenticatedBonusBuilderProjectIdRouteImport.update({
            id: '/$projectId',path: '/$projectId',getParentRoute: () => AuthenticatedBonusBuilderRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSupportRoute = AuthenticatedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProposalsRoute = AuthenticatedAdminProposalsRouteImport.update({
            id: '/proposals',path: '/proposals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPatternsRoute = AuthenticatedAdminPatternsRouteImport.update({
            id: '/patterns',path: '/patterns',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOverviewRoute = AuthenticatedAdminOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNotificationsRoute = AuthenticatedAdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminImpersonationRoute = AuthenticatedAdminImpersonationRouteImport.update({
            id: '/impersonation',path: '/impersonation',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAiUsageRoute = AuthenticatedAdminAiUsageRouteImport.update({
            id: '/ai-usage',path: '/ai-usage',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedWorkspacesWorkspaceIdIndexRoute = AuthenticatedWorkspacesWorkspaceIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdSettingsRoute = AuthenticatedWorkspacesWorkspaceIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdSecondTierRoute = AuthenticatedWorkspacesWorkspaceIdSecondTierRouteImport.update({
            id: '/second-tier',path: '/second-tier',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdProductsRoute = AuthenticatedWorkspacesWorkspaceIdProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdPasteRoute = AuthenticatedWorkspacesWorkspaceIdPasteRouteImport.update({
            id: '/paste',path: '/paste',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdImportsRoute = AuthenticatedWorkspacesWorkspaceIdImportsRouteImport.update({
            id: '/imports',path: '/imports',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdContactsRoute = AuthenticatedWorkspacesWorkspaceIdContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedWorkspacesWorkspaceIdAnomaliesRoute = AuthenticatedWorkspacesWorkspaceIdAnomaliesRouteImport.update({
            id: '/anomalies',path: '/anomalies',getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute
          })
const AuthenticatedTrainingCoursesCourseIdRoute = AuthenticatedTrainingCoursesCourseIdRouteImport.update({
            id: '/courses/$courseId',path: '/courses/$courseId',getParentRoute: () => AuthenticatedTrainingRoute
          })
const AuthenticatedSettingsIntegrationsPushManagementRoute = AuthenticatedSettingsIntegrationsPushManagementRouteImport.update({
            id: '/push-management',path: '/push-management',getParentRoute: () => AuthenticatedSettingsIntegrationsRoute
          })
const AuthenticatedAdminAccountsIndexRoute = AuthenticatedAdminAccountsIndexRouteImport.update({
            id: '/accounts/',path: '/accounts/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAccountsAccountIdRoute = AuthenticatedAdminAccountsAccountIdRouteImport.update({
            id: '/accounts/$accountId',path: '/accounts/$accountId',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAiUsageRoute: AuthenticatedAdminAiUsageRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminImpersonationRoute: AuthenticatedAdminImpersonationRoute,AuthenticatedAdminNotificationsRoute: AuthenticatedAdminNotificationsRoute,AuthenticatedAdminOverviewRoute: AuthenticatedAdminOverviewRoute,AuthenticatedAdminPatternsRoute: AuthenticatedAdminPatternsRoute,AuthenticatedAdminProposalsRoute: AuthenticatedAdminProposalsRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminSupportRoute: AuthenticatedAdminSupportRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminAccountsAccountIdRoute: AuthenticatedAdminAccountsAccountIdRoute,AuthenticatedAdminAccountsIndexRoute: AuthenticatedAdminAccountsIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedBonusBuilderRouteChildren = {
  AuthenticatedBonusBuilderProjectIdRoute: AuthenticatedBonusBuilderProjectIdRoute,AuthenticatedBonusBuilderIndexRoute: AuthenticatedBonusBuilderIndexRoute
}

const AuthenticatedBonusBuilderRouteWithChildren = AuthenticatedBonusBuilderRoute._addFileChildren(AuthenticatedBonusBuilderRouteChildren)




const AuthenticatedCalendarRouteChildren = {
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute
}

const AuthenticatedCalendarRouteWithChildren = AuthenticatedCalendarRoute._addFileChildren(AuthenticatedCalendarRouteChildren)




const AuthenticatedLinksRouteChildren = {
  AuthenticatedLinksIndexRoute: AuthenticatedLinksIndexRoute
}

const AuthenticatedLinksRouteWithChildren = AuthenticatedLinksRoute._addFileChildren(AuthenticatedLinksRouteChildren)




const AuthenticatedSettingsIntegrationsRouteChildren = {
  AuthenticatedSettingsIntegrationsPushManagementRoute: AuthenticatedSettingsIntegrationsPushManagementRoute
}

const AuthenticatedSettingsIntegrationsRouteWithChildren = AuthenticatedSettingsIntegrationsRoute._addFileChildren(AuthenticatedSettingsIntegrationsRouteChildren)



const AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,AuthenticatedSettingsExportsRoute: AuthenticatedSettingsExportsRoute,AuthenticatedSettingsIntegrationsRoute: AuthenticatedSettingsIntegrationsRouteWithChildren,AuthenticatedSettingsNotificationsRoute: AuthenticatedSettingsNotificationsRoute,AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,AuthenticatedSettingsSupportRoute: AuthenticatedSettingsSupportRoute,AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,AuthenticatedSettingsWorkspacesRoute: AuthenticatedSettingsWorkspacesRoute,AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteWithChildren = AuthenticatedSettingsRoute._addFileChildren(AuthenticatedSettingsRouteChildren)




const AuthenticatedSwipeRouteChildren = {
  AuthenticatedSwipeIndexRoute: AuthenticatedSwipeIndexRoute
}

const AuthenticatedSwipeRouteWithChildren = AuthenticatedSwipeRoute._addFileChildren(AuthenticatedSwipeRouteChildren)




const AuthenticatedTrainingRouteChildren = {
  AuthenticatedTrainingIndexRoute: AuthenticatedTrainingIndexRoute,AuthenticatedTrainingCoursesCourseIdRoute: AuthenticatedTrainingCoursesCourseIdRoute
}

const AuthenticatedTrainingRouteWithChildren = AuthenticatedTrainingRoute._addFileChildren(AuthenticatedTrainingRouteChildren)




const AuthenticatedWorkspacesWorkspaceIdRouteChildren = {
  AuthenticatedWorkspacesWorkspaceIdAnomaliesRoute: AuthenticatedWorkspacesWorkspaceIdAnomaliesRoute,AuthenticatedWorkspacesWorkspaceIdContactsRoute: AuthenticatedWorkspacesWorkspaceIdContactsRoute,AuthenticatedWorkspacesWorkspaceIdImportsRoute: AuthenticatedWorkspacesWorkspaceIdImportsRoute,AuthenticatedWorkspacesWorkspaceIdPasteRoute: AuthenticatedWorkspacesWorkspaceIdPasteRoute,AuthenticatedWorkspacesWorkspaceIdProductsRoute: AuthenticatedWorkspacesWorkspaceIdProductsRoute,AuthenticatedWorkspacesWorkspaceIdSecondTierRoute: AuthenticatedWorkspacesWorkspaceIdSecondTierRoute,AuthenticatedWorkspacesWorkspaceIdSettingsRoute: AuthenticatedWorkspacesWorkspaceIdSettingsRoute,AuthenticatedWorkspacesWorkspaceIdIndexRoute: AuthenticatedWorkspacesWorkspaceIdIndexRoute
}

const AuthenticatedWorkspacesWorkspaceIdRouteWithChildren = AuthenticatedWorkspacesWorkspaceIdRoute._addFileChildren(AuthenticatedWorkspacesWorkspaceIdRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedAnomaliesRoute: AuthenticatedAnomaliesRoute,AuthenticatedBonusBuilderRoute: AuthenticatedBonusBuilderRouteWithChildren,AuthenticatedCalendarRoute: AuthenticatedCalendarRouteWithChildren,AuthenticatedCommandCenterRoute: AuthenticatedCommandCenterRoute,AuthenticatedContactsRoute: AuthenticatedContactsRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDigestsRoute: AuthenticatedDigestsRoute,AuthenticatedImportsRoute: AuthenticatedImportsRoute,AuthenticatedLensesRoute: AuthenticatedLensesRoute,AuthenticatedLinksRoute: AuthenticatedLinksRouteWithChildren,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedPeopleRoute: AuthenticatedPeopleRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,AuthenticatedSwipeRoute: AuthenticatedSwipeRouteWithChildren,AuthenticatedTrainingRoute: AuthenticatedTrainingRouteWithChildren,AuthenticatedIntelligenceProgramComparisonRoute: AuthenticatedIntelligenceProgramComparisonRoute,AuthenticatedWorkspacesWorkspaceIdRoute: AuthenticatedWorkspacesWorkspaceIdRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,CheckoutReturnRoute: CheckoutReturnRoute,CompleteSignupRoute: CompleteSignupRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DemoRoute: DemoRoute,DocsRoute: DocsRoute,FaqRoute: FaqRoute,FeaturesRoute: FeaturesRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,AcceptInviteTokenRoute: AcceptInviteTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)